import { createStore } from 'vuex';
import auth from './modules/auth';
import clubs from './modules/clubs';
import user from './modules/user';
import offers from './modules/offers';
import homes from './modules/homes';
import search from './modules/search';


export default createStore({
  modules: {
    auth,
    clubs,
    user,
    offers,
    homes,
    search
  }
});
